export enum EPlaceholder {
  SearchGoodsByNameOrVendorCode = 'Искать по названию или артикулу товара',
  EnterOldPassword = 'Введите старый пароль',
  EnterNewPassword = 'Введите новый пароль',
  RepeatNewPassword = 'Введите новый пароль ещё раз',
  Select = 'Выбрать',
  SelectCompany = 'Выберите компанию',
  SelectUser = 'Выберите пользователя',
  AddFeedForExport = 'Добавьте фид для экспорта',
  AddCustomerId = 'Добавьте ID покупателя',
  EnterEmailAddress = 'Введите адрес электронной почты',
  EnterPassword = 'Введите пароль',
  EnterLastName = 'Введите фамилию',
  EnterFirstName = 'Введите имя',
  EnterPatronymic = 'Введите отчество',
  EnterName = 'Введите название',
  EnterINN = 'Введите ИНН',
  EnterKPP = 'Введите КПП',
  SearchByEmployees = 'Поиск по сотрудникам',
  SelectFromEmployeeList = 'Выберите из списка сотрудников',
  SelectFromCompanyLegalEntityList = 'Выберите из списка юр. лиц компании',
  SelectBrand = 'Выберите бренд',
  StartTypingAddress = 'Начните вводить ваш адрес',
  SpecifyAddress = 'Укажите адрес',
  SpecifyCity = 'Укажите город',
  SpecifyPostalCode = 'Укажите индекс',
}
